import {GetIsSelectNew} from "src/model/ProductMatch";
import {IsSelectNewAction, SET_IS_SELECT_NEW} from "src/actions/IsSelectNew";
import {SWITCH_AMAZON_STORE_START_NEW, SwitchStoreStartAction} from "src/actions/SelectedProductQueryAction";
import {isLoginMode} from "src/config/Config";

const initialState: GetIsSelectNew = {
    selectNew: !isLoginMode(),
    oldProduct: null
};

export default (
    state: GetIsSelectNew = initialState,
    action: IsSelectNewAction | SwitchStoreStartAction
): GetIsSelectNew => {
    switch (action.type) {
        case SET_IS_SELECT_NEW:
            return {
                selectNew: "selectNew" in action ? action.selectNew : state.selectNew,
                oldProduct: null
            };
        case SWITCH_AMAZON_STORE_START_NEW:
            return {
                selectNew: true,
                oldProduct: "product" in action ? action.product : null
            };
        default:
            return state;
    }
};

